import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from '../../shared/shared.module';
import { SipCardAssuredModule } from '../sip-card-assured/sip-card-assured.module';

import { EndedFundraiserSipDialogComponent } from './ended-fundraiser-sip-dialog.component';
import { DownloadAppBannerModule } from '../download-app-banner/download-app-banner.module';

@NgModule({
  declarations: [EndedFundraiserSipDialogComponent],
  exports: [EndedFundraiserSipDialogComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    SipCardAssuredModule,
    SharedModule,
    DownloadAppBannerModule
  ]
})
export class EndedFundraiserSipDialogModule { }
